import {
  BlockedUsersList,
  BlockedUsersSearchFilterSection,
} from '@exam-center/admin-blocked-users-list';
import { BlockedUserCreationButton } from '@exam-center/blocked-user-management';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { Flex, Paper, Text, Box } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';

export default function AdminBlockedUsersListPage() {
  return (
    <PermissionGuard
      requiredPermission={APP_PERMISSIONS.ADMIN_BLOCKLIST_MANAGEMENT.BLOCKED_USER.VIEW}
    >
      <Flex sx={(theme) => ({ p: theme.spacing(8, 6), justifyContent: 'space-between' })}>
        <Text variant='h1'>รายชื่อผู้ไม่มีสิทธิ์สอบ</Text>
        <BlockedUserCreationButton />
      </Flex>
      <Box sx={(theme) => ({ p: theme.spacing(6) })}>
        <Paper sx={(theme) => ({ p: theme.spacing(6) })}>
          <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(4) }}>
            <BlockedUsersSearchFilterSection />
            <BlockedUsersList />
          </Flex>
        </Paper>
      </Box>
    </PermissionGuard>
  );
}
